import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import Lottie from 'lottie-react';
import { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { common } from '../../../assets/js/common.js';
import { LOTTIE_ANIMATIONS } from '../../../assets/ui/lottie/index.js';
import { cn } from '../../../lib/utils.js';

const LoadingComponent = ({
  loading,
  message,
  type = "upleft",
  className
}) => {
  if (loading) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      type === "upleft" && /* @__PURE__ */ jsxs(
        "div",
        {
          className: cn(
            "fixed bg-white/80 grid place-items-center inset-0 z-[1001] loading-shift-wrap new",
            className
          ),
          children: [
            /* @__PURE__ */ jsx(
              Lottie,
              {
                animationData: LOTTIE_ANIMATIONS.aniLtv110,
                loop: true,
                autoplay: true,
                style: { width: 64 }
              }
            ),
            message && /* @__PURE__ */ jsx("div", { children: message })
          ]
        }
      ),
      type === "shift" && /* @__PURE__ */ jsx("div", { className: cn("loading-shift-wrap new", className), children: /* @__PURE__ */ jsx(
        "img",
        {
          src: common.asset(`/ui/loading.png?${Date.now()}`),
          alt: "로딩중입니다.",
          width: 64
        }
      ) })
    ] });
  } else {
    return null;
  }
};
const Loading = ({
  loading,
  className,
  appendToRoot = false,
  prefixClassName = "",
  message,
  type
}) => {
  const [el] = useState(document.createElement("div"));
  useEffect(() => {
    if (appendToRoot) {
      el.className = prefixClassName;
      const root = document.getElementById("root");
      const target = root?.hasChildNodes() ? root?.childNodes[0] : null;
      if (target) {
        target?.appendChild(el);
      } else {
        document.body.appendChild(el);
      }
      return () => {
        if (target) {
          target?.removeChild(el);
        } else {
          document.body.removeChild(el);
        }
      };
    }
  }, [appendToRoot, el]);
  const loadingComponent = /* @__PURE__ */ jsx(
    LoadingComponent,
    {
      loading,
      className: cn(prefixClassName ? "relative" : "", className),
      message,
      type
    }
  );
  return appendToRoot ? createPortal(loadingComponent, el) : loadingComponent;
};

export { Loading };
